/**
 * Reports page section registry.
 *
 * Each entry describes one tab on the unified Reports page. Adding a future
 * section (e.g. "דוח מטופלים") is a single new entry here — the page renders
 * the tab strip and the active section from this array.
 *
 * isVisible receives a permissions context: { canAccessFinance, isAdmin }.
 */

import {
  ChartPieSlice,
  CurrencyCircleDollar,
  UsersThree,
} from "@phosphor-icons/react";
import ClinicReportSection from "./ClinicReportSection";
import FinanceReportSection from "./FinanceReportSection";
import PatientReportSection from "./PatientReportSection";

const sectionRegistry = [
  {
    id: "clinic",
    label: "דוחות קליניקה",
    Icon: ChartPieSlice,
    isVisible: () => true,
    Component: ClinicReportSection,
  },
  {
    id: "finance",
    label: "דוח כספים",
    Icon: CurrencyCircleDollar,
    isVisible: ({ canAccessFinance }) =>
      canAccessFinance !== false && canAccessFinance !== null,
    Component: FinanceReportSection,
  },
  {
    id: "patients",
    label: "ייצוא דוחות",
    Icon: UsersThree,
    isVisible: () => true,
    Component: PatientReportSection,
    // Standalone sections don't consume the monthly report doc: the page
    // skips the shared month nav and the report loading/preparing gating.
    standalone: true,
  },
];

export default sectionRegistry;
